import React from 'react';

const PackageIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}>
            <path
                d="M1.57227 4.18979L6.82227 6.52313L7.1781 5.72396L1.9281 3.39062L1.57227 4.18979ZM7.43768 12.5402V6.12354H6.56268V12.5402H7.43768ZM7.1781 6.52313L12.4281 4.18979L12.0723 3.39062L6.82227 5.72396L7.1781 6.52313Z"
                fill="currentColor"
            />
            <path
                d="M1.75 9.97998V4.01832C1.75002 3.95066 1.76964 3.88446 1.8065 3.82773C1.84335 3.771 1.89586 3.72616 1.95767 3.69865L6.85767 1.52048C6.90247 1.50054 6.95096 1.49023 7 1.49023C7.04904 1.49023 7.09753 1.50054 7.14233 1.52048L12.0423 3.69865C12.1041 3.72616 12.1566 3.771 12.1935 3.82773C12.2304 3.88446 12.25 3.95066 12.25 4.01832V9.97998C12.25 10.0476 12.2304 10.1138 12.1935 10.1706C12.1566 10.2273 12.1041 10.2721 12.0423 10.2996L7.14233 12.4778C7.09753 12.4978 7.04904 12.5081 7 12.5081C6.95096 12.5081 6.90247 12.4978 6.85767 12.4778L1.95767 10.2996C1.89586 10.2721 1.84335 10.2273 1.8065 10.1706C1.76964 10.1138 1.75002 10.0476 1.75 9.97998Z"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M4.375 2.625L9.41733 4.86617C9.47914 4.89368 9.53165 4.93851 9.5685 4.99525C9.60536 5.05198 9.62498 5.11818 9.625 5.18583V7.29167"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default PackageIcon;
